import { cn } from '@w/ui/lib/utils'
import type { ReviewBlock } from './block'

export type ReviewPresentation = Pick<
  ReviewBlock,
  'change' | 'display' | 'state'
>

export interface ReviewPresentationDataAttributes {
  'data-review-change': ReviewBlock['change']
  'data-review-display': ReviewBlock['display']
  'data-review-state': ReviewBlock['state']
}

export function reviewPresentationClassName(review: ReviewPresentation) {
  const suggestedBlock =
    review.display === 'block' && review.state === 'suggested'
  const suggestedAddition =
    review.change === 'add' && review.state === 'suggested'
  const suggestedDeletion =
    review.change === 'delete' && review.state === 'suggested'
  const approvedAddition =
    review.change === 'add' && review.state === 'approved'
  return cn(
    suggestedAddition && 'bg-surface-success text-on-surface-success',
    suggestedDeletion &&
      'bg-surface-error text-on-surface-error no-underline',
    approvedAddition && 'text-on-surface no-underline',
    review.change === 'delete' &&
      review.state === 'approved' &&
      'bg-surface-error/50 no-underline',
    suggestedBlock && 'border-l-4 ps-3',
    suggestedBlock && review.change !== 'delete' && 'border-success-border',
    suggestedBlock && review.change === 'delete' && 'border-error-border',
  )
}

export function reviewPresentationDataAttributes(
  review: ReviewPresentation,
): ReviewPresentationDataAttributes {
  return {
    'data-review-change': review.change,
    'data-review-display': review.display,
    'data-review-state': review.state,
  }
}
